import React, { useEffect } from "react";
import NavHook from "../../components/Nav/NavHook";
import PageLayout from "../../components/PageLayout/PageLayout";
import PlasmicHook from "../../components/PageLayout/PlasmicHook";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export default function Page({
	locale,
	head,
	navigation,
	body,
	footer,
	slug,
	...rest
}) {
	useEffect(() => {
		window?.rudderanalytics?.page();
	}, []);
	return (
		<PageLayout
			head={head}
			locale={locale}
			navigation={navigation}
			body={body}
			footer={footer}
			slug={slug}
		/>
	);
}

export async function getStaticPaths({ locales }) {
	const slugs = [
		"appetizers",
		"sauces_condiments_and_spices",
		"beers",
		"world_cuisines",
		"chocolates_and_sweets",
		"biscuits_and_cakes",
		"dried_fruits",
		"preserves_and_jars",
		"pasta_rice_and_cereals",
		"ready_meals_and_soups",
		"desserts_and_compotes",
		"coffee_tea_and_hot_drinks",
		"dairy_and_cheeses",
		"spreads_jams_and_honey",
		"milks_and_plant_drinks",
		"cereal_and_rusk"
	];

	const paths = locales.flatMap((locale) => {
		// Add your catalog slugs here
		return slugs.map((slug) => ({
			params: { slug },
			locale,
		}));
	});

	return {
		paths,
		fallback: false,
	};
}

export const getStaticProps = async ({ params, locale }) => {
	const page = {}; //TODO: get page data from strapi
	const slug = params?.slug ? params?.slug : [];

	//define the head data
	const head = {
		title: page?.seo?.metaTitle || "Bene Bono",
		og: {
			title: page?.seo?.metaTitle || "Bene Bono",
			siteName: "Bene Bono",
			url: `benebono.${locale}`,
			description: page?.seo?.metaDescription || "",
			image: page?.seo?.metaImage?.data?.attributes.url || "",
		},
	};

	//define the navigation data
	const mainNav = await NavHook(locale, "main");
	const navigation = {
		links: mainNav,
		name: page?.header?.data?.attributes.name || null, //return navigation's name to be used in navigation component logic (spain/catalan flag), should be done in a better way (multiple nav components or component props)
	};

	//define the body data
	const plasmic = await PlasmicHook("catalog", locale, params);
	if (!plasmic) {
		throw new Error("No Plasmic design found");
	}
	const body = {
		plasmic,
	};

	//define the footer data
	const footerNav = await NavHook(locale, "footer");
	const footer = {
		links: footerNav,
	};

	const REVALIDATE_TIME = process.env.PLASMIC_ENV === "production" ? 1200 : 1;

	return {
		props: {
			...(await serverSideTranslations(locale)),
			locale,
			head,
			navigation,
			body,
			footer,
			slug,
		},
		revalidate: REVALIDATE_TIME,
	};
};
